import React from 'react';
import { DashboardCard } from './DashboardCard';
import { DollarSignIcon, PencilRulerIcon, PackageIcon, LineChartIcon, BarChart3Icon, ArrowUpDownIcon, FilterIcon, ArrowRightIcon, TrendingUpIcon } from 'lucide-react';
export function QuotesOverview() {
  // Mock data
  const quotesData = {
    total: 2392,
    pivots: 3716,
    spareParts: 0,
    linears: 0,
    conversionRate: '0%'
  };
  const regions = [{
    name: 'Aisco MENA',
    value: 6,
    max: 1600,
    percentage: 0.4
  }, {
    name: 'Aisco AFRICA',
    value: 12,
    max: 1600,
    percentage: 0.8
  }, {
    name: 'Aisco EUROPE',
    value: 650,
    max: 1600,
    percentage: 40.6
  }, {
    name: 'Aisco AMERICA',
    value: 1590,
    max: 1600,
    percentage: 99.4
  }, {
    name: 'Aisco ANZ',
    value: 94,
    max: 1600,
    percentage: 5.9
  }];
  const dealers = [{
    name: 'TEXAS INTERNATIONAL IRRIGATION',
    count: 167
  }, {
    name: 'UWR',
    count: 113
  }, {
    name: 'I-BEAM Irrigation',
    count: 111
  }, {
    name: 'AQUADOC',
    count: 97
  }, {
    name: 'NORTHERN IRRIGATION SYSTEMS',
    count: 92
  }, {
    name: 'CAN AGRO LLP',
    count: 90
  }, {
    name: 'VK SALES & SERVICE',
    count: 81
  }, {
    name: 'IMPER REGAS Lda',
    count: 74
  }];
  return <div className="space-y-6" data-id="element-1942" data-mp="1kqexrweo96ah">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1943" data-mp="1ft6oklbi4cld">
        <DashboardCard icon={<DollarSignIcon size={20} className="text-blue-400" data-id="element-1945" data-mp="1uqpalfwsobp4" />} title="Total Quotes" className="md:col-span-2" data-id="element-1944" data-mp="1fw190cuilxes">
          <div className="flex flex-col" data-id="element-1946" data-mp="1pse2b9m5e990">
            <div className="text-5xl font-bold text-white mb-6" data-id="element-1947" data-mp="1prm4rt8zq1g3">
              {quotesData.total}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-1948" data-mp="23ldd4yazjfa8">
              <QuoteTypeCard icon={<PencilRulerIcon size={18} data-id="element-1950" data-mp="1zjs79wwvc19j" />} label="Pivots" value={quotesData.pivots} data-id="element-1949" data-mp="1zi7di9idomcq" />
              <QuoteTypeCard icon={<PackageIcon size={18} data-id="element-1952" data-mp="2df40u0zaflov" />} label="Spare parts" value={quotesData.spareParts} data-id="element-1951" data-mp="2dhq8s1q3c37m" />
              <QuoteTypeCard icon={<LineChartIcon size={18} data-id="element-1954" data-mp="164xsoo3515tc" />} label="Linears" value={quotesData.linears} data-id="element-1953" data-mp="28g9b0f2wkwv9" />
            </div>
            <div className="h-40 relative" data-id="element-1955" data-mp="1a69nd80vch8e">
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between px-2" data-id="element-1956" data-mp="1a72n3p1eu6h1">
                {Array.from({
                length: 12
              }, (_, i) => <div key={i} className="flex flex-col items-center" data-id="element-1957" data-mp="1jww0mvl44vnx">
                      <div className="w-8 bg-blue-500 rounded-t-sm" style={{
                  height: `${Math.random() * 100 + 20}px`
                }} data-id="element-1958" data-mp="1ovfm6uvso5fr"></div>
                      <div className="text-xs text-blue-300 mt-1" data-id="element-1959" data-mp="1tsyy3o50s64j">
                        {new Date(0, i).toLocaleString('default', {
                    month: 'short'
                  })}
                      </div>
                    </div>)}
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<TrendingUpIcon size={20} className="text-blue-400" data-id="element-1961" data-mp="8h7ajvckbgiw" />} title="Conversion Rate" data-id="element-1960" data-mp="3k74hkfpqdrs">
          <div className="flex flex-col items-center justify-center h-full" data-id="element-1962" data-mp="8j0irf2tq8t0">
            <div className="relative w-40 h-40 mb-4" data-id="element-1963" data-mp="yzde9wt6ad5">
              <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-1964" data-mp="3sbu0ge0cdu09">
                <circle cx="50" cy="50" r="40" fill="transparent" stroke="#1e40af" strokeWidth="15" data-id="element-1965" data-mp="3saiwad2zik8m" />
                <circle cx="50" cy="50" r="40" fill="transparent" stroke="#3b82f6" strokeWidth="15" strokeDasharray="251.2" strokeDashoffset="251.2" transform="rotate(-90 50 50)" data-id="element-1966" data-mp="3ie65bmytqkhk">
                  <animate attributeName="stroke-dashoffset" from="251.2" to="251.2" dur="1s" fill="freeze" data-id="element-1967" data-mp="jug0p5p5cm0n" />
                </circle>
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1968" data-mp="9xl3cq4m0rny">
                <div className="text-3xl font-bold text-white" data-id="element-1969" data-mp="5xaqctieh0zl">
                  {quotesData.conversionRate}
                </div>
                <div className="text-sm text-blue-300" data-id="element-1970" data-mp="2uq530vs8o0al">Conversion</div>
              </div>
            </div>
            <div className="text-center" data-id="element-1971" data-mp="2qlox4uimksvd">
              <div className="text-sm text-blue-300 mb-2" data-id="element-1972" data-mp="iek29u3hlyuj">
                Opportunities for improvement
              </div>
              <button className="inline-flex items-center px-3 py-1.5 rounded-lg bg-blue-500/20 text-blue-300 hover:bg-blue-500/30 transition-colors text-sm" data-id="element-1973" data-mp="n6256np2m9i5">
                View Analysis
                <ArrowRightIcon size={14} className="ml-1" data-id="element-1974" data-mp="defls42kx44b" />
              </button>
            </div>
          </div>
        </DashboardCard>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1975" data-mp="112p2irkxr1ol">
        <DashboardCard icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1977" data-mp="163ctjd95ziit" />} title="Regional Distribution" className="md:col-span-3" data-id="element-1976" data-mp="162tlqpd8aaii">
          <div className="space-y-4" data-id="element-1978" data-mp="s66e9snng1yc">
            {regions.map(region => <div key={region.name} className="space-y-2" data-id="element-1979" data-mp="w4dsogun4r6d">
                <div className="flex justify-between" data-id="element-1980" data-mp="3cukltvvp7xv6">
                  <span className="text-sm text-blue-300" data-id="element-1981" data-mp="3ct14e1yb3grt">{region.name}</span>
                  <span className="text-sm font-medium text-white" data-id="element-1982" data-mp="3gwz70mmub9pm">
                    {region.value} quotes
                  </span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-1983" data-mp="34dbw7u78mzbi">
                  <div className="bg-blue-500 h-2.5 rounded-full" style={{
                width: `${region.percentage}%`
              }} data-id="element-1984" data-mp="3jakrv03kqp91"></div>
                </div>
                <div className="flex justify-between text-xs text-slate-400" data-id="element-1985" data-mp="3ec13yu5f73e1">
                  <span data-id="element-1986" data-mp="2qmyo9rucjkm6">0</span>
                  <span data-id="element-1987" data-mp="2qjszkdpmqkqz">{region.max}</span>
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <DashboardCard icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1989" data-mp="30byofekl4m1y" />} title="Quotes by Dealers" footer={<div className="flex justify-between text-sm text-blue-300" data-id="element-1990" data-mp="2vkgpsx61axk5">
            <span data-id="element-1991" data-mp="2vj5kgswxxhqx">Showing 8 of 32 dealers</span>
            <button className="text-blue-400 hover:text-white" data-id="element-1992" data-mp="27ue0goti85p8">View All</button>
          </div>} data-id="element-1988" data-mp="30bgly07bxbll">
        <div className="flex justify-end mb-4" data-id="element-1993" data-mp="22v9rnzahs9zf">
          <div className="flex items-center space-x-2" data-id="element-1994" data-mp="22ui6lieitune">
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1995" data-mp="2sjf42nxc3a8z">
              <ArrowUpDownIcon size={16} data-id="element-1996" data-mp="2wkil3dr4bcbs" />
            </button>
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1997" data-mp="31ca5f6joklth">
              <FilterIcon size={16} data-id="element-1998" data-mp="36atpt2imlpjq" />
            </button>
          </div>
        </div>
        <div className="space-y-4" data-id="element-1999" data-mp="29m4bfm67jf2i">
          {dealers.map((dealer, index) => <div key={index} className="flex items-center" data-id="element-2000" data-mp="29nyron6jaj09" data-mpi={index}>
              <div className="flex-1 text-white" data-id="element-2001" data-mp="2dnpszktoshj1">{dealer.name}</div>
              <div className="w-1/2" data-id="element-2002" data-mp="2ilr8jvrwlypr">
                <div className="flex items-center" data-id="element-2003" data-mp="2ikpqh7ch0byj">
                  <div className="flex-1 mr-4" data-id="element-2004" data-mp="2nlwviyn8ax1i">
                    <div className="w-full bg-slate-700/50 rounded-full h-2.5" data-id="element-2005" data-mp="2nmoriakqmwsb">
                      <div className="bg-blue-500 h-2.5 rounded-full" style={{
                    width: `${dealer.count / 167 * 100}%`
                  }} data-id="element-2006" data-mp="3u0o31l6uxg4i"></div>
                    </div>
                  </div>
                  <div className="text-blue-300 text-sm w-10 text-right" data-id="element-2007" data-mp="1ncnmpm2zqdgz">
                    {dealer.count}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </DashboardCard>
    </div>;
}
function QuoteTypeCard({
  icon,
  label,
  value
}) {
  return <div className="bg-slate-800/50 rounded-lg p-4" data-id="element-2008" data-mp="18nrjc2bvpomp">
      <div className="flex justify-between items-center mb-2" data-id="element-2009" data-mp="14n8pk2qfe8hv">
        <div className="flex items-center" data-id="element-2010" data-mp="14kmjy8n3i32a">
          <div className="p-2 rounded-lg bg-slate-700/50 mr-3" data-id="element-2011" data-mp="zncwuzn6i3hm">
            <span className="text-blue-300" data-id="element-2012" data-mp="zpz2uuuf8axq">{icon}</span>
          </div>
          <div className="text-sm text-blue-300" data-id="element-2013" data-mp="uorvuy03rfs4">{label}</div>
        </div>
        <div className="text-xl font-bold text-white" data-id="element-2014" data-mp="pqhz4iyqc74e">{value}</div>
      </div>
    </div>;
}